export default __webpack_public_path__ + "static/media/visitaCoppia.08debf26.png";